import React from 'react'

const TaskIcons = ({ type }) => {
  switch (type) {
    case 'article':
      return <Compass />
    default:
      return <Compass />
  }
}
export default TaskIcons

const Compass = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        d="M10.5854 10.5858L16.9493 7.05029L13.4138 13.4143L7.0498 16.9498L10.5854 10.5858Z"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#08467C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
